import { createFileRoute } from '@tanstack/react-router';
import { EventDetailPage } from '../../features/events/EventDetailPage.jsx';

function EventDetailRoute() {
  const { eventId } = Route.useParams();
  return <EventDetailPage key={eventId} eventId={eventId} />;
}

export const Route = createFileRoute('/_app/events/$eventId')({ component: EventDetailRoute });
